import jwtDecode from 'jwt-decode';
import { isArray } from 'util';

export const getIsAdminByToken = (token: string): boolean => {
    const tokenData: any = jwtDecode(token);
    if (tokenData.is_admin) {
        return !!tokenData.is_admin;
    }
    return false;
};

export const getPermissionsByToken = (token: string | null): string[] => {
    if (token) {
        const tokenData: any = jwtDecode(token);
        if (tokenData.permissions && isArray(tokenData.permissions)) {
            return tokenData.permissions;
        }
    }
    return [];
};

export const Permissions = {
    admin: 'manage admin',
    users: 'manage users',
    admins: 'manage admins',
    productCategories: 'manage product_categories',
    timetables: 'manage timetables',
    shipping: "manage shipping",
    products: "manage products",
    donations: "manage donations",
    productAttributes: "manage product_attributes",
    payments: "manage payments",
    discounts: "manage user discounts",
    coupons: "manage coupons",
    orders: "manage orders",
    banners: "manage banners",
    productListAds: "manage product_list_ads",
    cms: "manage cms",
    urlAliases: "manage url_aliases",
    dashboard: "manage dashboard",
    productVotes: "manage product_votes",
    loginAsUser: "login as user",
};



// WEBPACK FOOTER //
// ./src/utils/Auth.ts